import { render, staticRenderFns } from "./close-process-form.vue?vue&type=template&id=0056a0ee"
import script from "./close-process-form.vue?vue&type=script&lang=js"
export * from "./close-process-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports